import { createContext } from 'react';

/**
 * React Context that signals whether the current user has read-only access.
 * Provided once in Layouts.General; consumed by ContextMenuItemImpl to
 * auto-hide context menu entries annotated with `writeAction: true`.
 *
 * Default value is `false` (not read-only).
 */
export const ReadOnlyContext = createContext(false);
